import * as React from 'react'

export default (props) =>
    <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="17.5" viewBox="0 0 17.5 17.5" {...props}>
        <path d="M1.8 1.5c-.1 0-.3.1-.3.3v10c0 .1.1.3.3.3h2c.4 0 .8.3.8.8v2.4l3.8-3c0-.2.2-.3.4-.3h7c.1 0 .3-.1.2-.3v-10c0-.1-.1-.3-.3-.3H1.8zm2 16c-.4 0-.8-.3-.8-.7v-3.2H1.8c-1 0-1.8-.8-1.8-1.8v-10C0 .8.8 0 1.8 0h14c1 0 1.8.8 1.8 1.8v10c0 1-.8 1.8-1.8 1.8H9l-4.8 3.8c-.1 0-.3.1-.4.1z" fillRule="evenodd" clipRule="evenodd" />
    </svg>
